import { useState } from "react";

interface ProductDemoProps {
  screenshot: string;
  screenshotAlt: string;
  videoId: string | null;
  videoLabel: string;
}

const ProductDemo = ({ screenshot, screenshotAlt, videoId, videoLabel }: ProductDemoProps) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="overflow-hidden rounded-[18px] border border-border bg-card shadow-card">
      <div className="flex h-[34px] items-center gap-1.5 border-b border-border bg-muted px-3.5">
        <span className="h-2 w-2 rounded-full bg-border" />
        <span className="h-2 w-2 rounded-full bg-border" />
        <span className="h-2 w-2 rounded-full bg-border" />
      </div>

      {playing && videoId ? (
        <div className="aspect-video">
          <iframe
            className="h-full w-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title={videoLabel}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <button
          type="button"
          className="relative block w-full"
          onClick={() => videoId && setPlaying(true)}
          disabled={!videoId}
          aria-label={videoId ? `Assistir: ${videoLabel}` : screenshotAlt}
        >
          <img src={screenshot} alt={screenshotAlt} className="block h-auto w-full" />
          {videoId && (
            <span className="absolute inset-0 flex items-center justify-center bg-black/[.14]">
              <span className="flex h-[62px] w-[62px] items-center justify-center rounded-full bg-white/95 shadow-[0_8px_26px_-8px_rgba(0,0,0,.4)]">
                <svg width="22" height="22" viewBox="0 0 24 24" className="ml-[3px] fill-primary">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
            </span>
          )}
        </button>
      )}

      <div className="border-t border-border bg-muted px-4 py-[11px] text-[11.5px] text-muted-foreground">
        {videoLabel}
      </div>
    </div>
  );
};

export default ProductDemo;
